export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6739.c596e33a.jpg";